import apiServices from './apiServices';
import { GetTrustFund, CompetitionReportReq }  from './dtos';



class adminServices  {
    

     baseSvc = new apiServices();
     client = this.baseSvc.client;

   
    constructor() {
     
      }


      // Downloads the admin competition report CSV for the given (inclusive) date range.
      async downloadCompetitionReport(start?: string, end?: string)
      {
        const req = new CompetitionReportReq({ start: start || undefined, end: end || undefined });
        const url = this.client.createUrlFromDto("GET", req);

        const res = await fetch(url, {
          headers: { Authorization: "Bearer " + this.client.bearerToken },
        });
        if (!res.ok) {
          throw new Error(res.status === 401 ? "Not authorized" : "Download failed (" + res.status + ")");
        }

        const disposition = res.headers.get("Content-Disposition") || "";
        const match = /filename="?([^";]+)"?/.exec(disposition);
        const filename = match ? match[1] : "competition-report.csv";

        const blob = await res.blob();
        const href = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = href;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(href);
      }

      getTrustFund()
      {
        const req = new GetTrustFund();
        return this.client.get(req);
        
      }
    

}


export default adminServices;
